"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Box, Text, useMultiStyleConfig } from "@chakra-ui/react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { motion } from "framer-motion";
import { SvgSpriteConsumer } from "../SvgSprite";
import { colors } from "../../../theme/foundations/generated";
const SearchPanel = ({ children, title, subtitle, mandatoryLabel, duration = 1, }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [overflow, setOverflow] = useState("hidden");
    const styles = useMultiStyleConfig("SearchPanel");
    return (_jsxs(Box, Object.assign({ sx: styles.searchPanelContainer }, { children: [_jsx(Box, Object.assign({ sx: styles.title }, { children: _jsx(Text, Object.assign({ variant: "title.desktopCard", color: "semantic.text.primary" }, { children: title })) })), _jsx(motion.div, Object.assign({ style: {
                    display: "grid",
                }, initial: {
                    gridTemplateRows: isCollapsed ? "0fr" : "1fr",
                }, animate: {
                    gridTemplateRows: isCollapsed ? "0fr" : "1fr",
                }, transition: {
                    duration,
                }, onAnimationStart: () => setOverflow("hidden"), onAnimationComplete: () => isCollapsed ? setOverflow("hidden") : setOverflow("visible") }, { children: _jsx(Box, Object.assign({ sx: {
                        overflow,
                    } }, { children: _jsxs(Box, Object.assign({ sx: Object.assign(Object.assign({}, styles.body), { overflow }) }, { children: [_jsxs(Box, Object.assign({ sx: styles.subtitle }, { children: [subtitle ? (_jsx(Text, Object.assign({ variant: "subtitle.card", color: "semantic.text.tertiary" }, { children: subtitle }))) : null, mandatoryLabel ? (_jsxs(Text, Object.assign({ variant: "subtitle.card", color: "semantic.text.error" }, { children: ["*", mandatoryLabel] }))) : null] })), children] })) })) })), _jsx(motion.button, Object.assign({ style: {
                    position: "absolute",
                    bottom: "-1rem",
                    right: "50%",
                    width: "2rem",
                    height: "2rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: `${colors.semantic.cta.secondary}`,
                    borderRadius: "50%",
                }, initial: {
                    rotate: isCollapsed ? 180 : 0,
                }, animate: {
                    rotate: isCollapsed ? 180 : 0,
                }, transition: {
                    duration: 0.1,
                }, onClick: () => setIsCollapsed(!isCollapsed) }, { children: _jsx(SvgSpriteConsumer, { svgId: "chevronUp24", size: 16, color: "semantic.icon.inverse" }) }))] })));
};
export default SearchPanel;
//# sourceMappingURL=SearchPanel.js.map